import { type AxiosRequestConfig } from 'axios'

const getNotifications = (): AxiosRequestConfig => {
  return {
    method: 'GET',
    url: '/notifications/list'
  }
}

export { getNotifications }
